export default "__VITE_ASSET__Dz2aG0Hf__"